import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { countries } from "countries-list";
import { setCurrencySymbol } from "../Redux/currencySlice";

interface Option {
  label: string;
  value: string;
  currency: string;
  flag: string;
}

const currencySymbols: Record<string, string> = {
  INR: "₹",
  USD: "$",
  GBP: "£",
  EUR: "€",
  JPY: "¥",
  AUD: "A$",
  CAD: "C$",
  CHF: "CHF",
  CNY: "¥",
  SGD: "S$",
  AED: "د.إ",
};

const CountryDropdown: React.FC = () => {
  const dispatch = useDispatch();

  const [countryOptions, setCountryOptions] = useState<Option[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<Option | null>(null);

  useEffect(() => {
    const options: Option[] = Object.entries(countries)
      .filter(([code]) => /^[A-Z]{2}$/.test(code))
      .map(([code, country]: any) => ({
        label: country.name,
        value: code,
        currency: country.currency || "",
        flag: code.toLowerCase(),
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    setCountryOptions(options);

    const india = options.find(
      (country) => country.label === "India"
    );

    if (india) {
      setSelectedCountry(india);
      dispatch(setCurrencySymbol("₹"));
    }
  }, [dispatch]);

  const handleSelect = (selectedOption: Option | null) => {
    if (!selectedOption) return;

    setSelectedCountry(selectedOption);

    dispatch(
      setCurrencySymbol(
        currencySymbols[selectedOption.currency] ||
          selectedOption.currency ||
          ""
      )
    );
  };

  const formatOptionLabel = ({ label, flag }: Option) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <img
        src={`https://flagcdn.com/24x18/${flag}.png`}
        alt={label}
        width={24}
        height={18}
        loading="lazy"
        onError={(e) => {
          (e.target as HTMLImageElement).src =
            "https://via.placeholder.com/24x18";
        }}
      />
      <span>{label}</span>
    </div>
  );

  return (
    <Select
      options={countryOptions}
      value={selectedCountry}
      onChange={handleSelect}
      formatOptionLabel={formatOptionLabel}
      getOptionValue={(option) => option.value}
      placeholder="Select Country"
      isSearchable
      styles={{
        container: (base) => ({
          ...base,
          width: 200,
        }),
        menu: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
    />
  );
};

export default CountryDropdown;